export const formatNumber = (number, zeroValue = '') => {
  if (number === 0) { return zeroValue }
  return parseInt(number, 10).toLocaleString()
}



// WEBPACK FOOTER //
// ./src/formatter.js